module.exports = __webpack_public_path__ + "img/7.76d33acb.jpg";